import React from "react";
import { Link } from "react-router-dom";
import notFoundImage from "/not-found.svg";
import { FaArrowRight } from "react-icons/fa";

const NotFound = () => {
  return (
    <>
      <section>
        <div className="flex flex-col items-center justify-center min-h-screen text-center">
          <img
            src={notFoundImage}
            alt="Not Found"
            className="w-[260px] md:w-[340px] mx-auto mb-6"
          />

          <p className="text-lg md:text-4xl text-primary mb-2 font-bold md:whitespace-nowrap">
            Üzgünüz, Bu Sayfayı Bulamıyoruz
          </p>
          <p className="text-sm md:text-lg text-primary mb-6 md:whitespace-nowrap">
            Aradığınız sayfa kaldırılmış, adı değiştirilmiş veya geçici olarak kullanılamıyor olabilir.
          </p>

          <Link to="/">
          <button className="bg-[var(--color-primary)] hover:bg-[var(--color-secondary)] text-white font-semibold px-8 py-4 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 text-lg flex items-center gap-2">
              Ana Sayfaya Dön
              <FaArrowRight className="text-xl" />
            </button>
          </Link>
        </div>
      </section>
    </>
  );
};

export default NotFound;
